// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../../fetch.pb.js";
export var ListThreadsRequest_Sort;
(function (ListThreadsRequest_Sort) {
    ListThreadsRequest_Sort["REQUESTED_SEND_AT_ASC"] = "REQUESTED_SEND_AT_ASC";
    ListThreadsRequest_Sort["REQUESTED_SEND_AT_DESC"] = "REQUESTED_SEND_AT_DESC";
    ListThreadsRequest_Sort["CREATED_AT_ASC"] = "CREATED_AT_ASC";
    ListThreadsRequest_Sort["CREATED_AT_DESC"] = "CREATED_AT_DESC";
})(ListThreadsRequest_Sort || (ListThreadsRequest_Sort = {}));
export var ListThreadsRequest_Sort_index;
(function (ListThreadsRequest_Sort_index) {
    ListThreadsRequest_Sort_index[ListThreadsRequest_Sort_index["REQUESTED_SEND_AT_ASC"] = 0] = "REQUESTED_SEND_AT_ASC";
    ListThreadsRequest_Sort_index[ListThreadsRequest_Sort_index["REQUESTED_SEND_AT_DESC"] = 1] = "REQUESTED_SEND_AT_DESC";
    ListThreadsRequest_Sort_index[ListThreadsRequest_Sort_index["CREATED_AT_ASC"] = 2] = "CREATED_AT_ASC";
    ListThreadsRequest_Sort_index[ListThreadsRequest_Sort_index["CREATED_AT_DESC"] = 3] = "CREATED_AT_DESC";
})(ListThreadsRequest_Sort_index || (ListThreadsRequest_Sort_index = {}));
export const ManualSmsScheduledService = {
    Schedule(fn, req) {
        return fn(`/messaging/scheduled/manual-sms/v1/schedule`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetThread(fn, req) {
        return fn(`/messaging/scheduled/manual-sms/v1/thread?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListThreads(fn, req) {
        return fn(`/messaging/scheduled/manual-sms/v1/threads/list?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListThreadsCount(fn, req) {
        return fn(`/messaging/scheduled/manual-sms/v1/threads/count?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    Delete(fn, req) {
        try {
            fm.validateUrlParam(req["messageId"], "messageId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/scheduled/manual-sms/v1/${req["messageId"]}?${fm.renderURLSearchParams(req, ["messageId"])}`, { method: "DELETE" });
    },
};
